import React, { useState, useEffect, useRef } from "react";
import Spinner from "../spinner/spinner";
import Questionaire from "./questionaire";
import {useNavigate } from "react-router-dom";
import { withParams } from "../../utils/withParams";
import {connect} from "react-redux";
import {MalwareModule,AddModuleAnswers,AddGameTime} from "../../redux/action/action";
import { Data } from "../data/malwareData";
import Image1 from "../Rander/malwareboat.png";
// import Flag from "../Rander/flags/malware.gif";

let detourCounter = 0;
function Question(props) {

  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [showAnswers, setShowAnswers] = useState(false);
  const [wrongAnswers, setWrongAnswers] = useState(false);
  const [time, setTime] = useState(false);
  const [firstIndex, setForFirstIndex] = useState(true);
  const [counter, setCounter] = useState(0);
  const [running, setRunning] = useState(false);
  // Tracks wrong answers for the CURRENT attempt only; it resets on every
  // fresh mount of this module (e.g. after a detour/retry), so a failed
  // attempt's mistakes never get added on top of the attempt that actually
  // completes the module.
  const [wrongCount, setWrongCount] = useState(0);
  // Guards against handleNextModule dispatching its totals more than once
  // (e.g. a rapid double-click on "Next" before navigate() unmounts this
  // component), which would otherwise permanently inflate the cumulative
  // totals submitted once at the end.
  const moduleCommitted = useRef(false);


   // Calculate Time...............
   useEffect(() => {
    let interval;

    if (!running) {
      return () => {};
    }
    interval = setInterval(() => {
      setCounter((counter) => counter + 1);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [running]);

  useEffect(() => {
       const data = Data();
       const quiz_questions = data.map((question) => ({
          ...question,
          answers: [
            question.correct_answer,
            ...question.incorrect_answers,
          ].sort(() => Math.random() - 0.5),
        })).sort(() => Math.random() - 0.5);
        setQuestions(quiz_questions);
  }, []);

  const handleAnswer = (answer) => {
    setRunning(true);
    if (!showAnswers) {
      const isCorrect = answer === questions[currentIndex].correct_answer;
      if (isCorrect) {
        setScore(score + 1);
        setWrongAnswers(false);
      }
      else{
        setWrongAnswers(true);
        setWrongCount(wrongCount + 1);
      }
    }
    setShowAnswers(true);
    handleNextQuestion();
  };

  const handleNextQuestion = () => {
    setCurrentIndex(currentIndex + 1);
    setShowAnswers(false);
    if(currentIndex === 2)
    {
      setTimeout(() => {
        setTime(true);
      }, 2000);
    }
    if(currentIndex === 1 && score === 0)
    {
      setForFirstIndex(false);
    }
  };
  const handleDetour = () => {
    navigate(withParams("/cyberisland/malwaretoolkit"));
    setScore(0);
    // navigate() above goes to a different route (the toolkit screen), which
    // remounts this component fresh on return — but reset defensively too,
    // in case that routing ever changes to an in-place retry.
    setWrongCount(0);
    detourCounter = detourCounter + 1;
  }
  const handleNextModule = () => {
    // Guard against double-dispatch (e.g. a rapid double-click) before
    // navigate() below has unmounted this component.
    if (moduleCommitted.current) {
      return;
    }
    moduleCommitted.current = true;

    props.MalwareModule(score,detourCounter);
    // The campaign result API is called once at the very end (see Result
    // screen) instead of after every level, so only accumulate this level's
    // time and (this attempt's) answer tally here.
    props.AddGameTime(counter);
    props.AddModuleAnswers(score, wrongCount);

    navigate(withParams("/cyberisland/ransomwaremodule"));
  }

  return (
    <>
    {currentIndex === 3 && wrongAnswers === false && score === 3 && time === true ?
    <>
      <img src="https://dqib2w4u3w0ne.cloudfront.net/Rander/flags/malware.gif" alt="Logo" className="container-fluid p-0 set-height" />
      <button onClick = {handleNextModule} className="next-module">Next</button>
    </>
    :
    <div className="container-fluid p-0 set-height">
      {currentIndex === 0 &&
       <img src={Image1} alt="Logo" className="set-boat4" />
      }
      {currentIndex === 1 && wrongAnswers === false && score === 1 ?
       <img src={Image1} alt="Logo" className="set-boat5" />
      :
      currentIndex === 1 && wrongAnswers === true && score === 1 &&
      <img src={Image1} alt="Logo" className="set-boat5-move" />
      }
      {currentIndex === 2 && wrongAnswers === false && (score === 2) ?
       <img src={Image1} alt="Logo" className="set-boat6" />
      :
      currentIndex === 2 && wrongAnswers === true && (score === 2 || score === 1) &&
      <img src={Image1} alt="Logo" className="set-boat6-move" />
      }
      {currentIndex === 2 && wrongAnswers === false && score === 1 &&
       <img src={Image1} alt="Logo" className="set-boat6-from-index" />
      }
      {currentIndex === 3 && wrongAnswers === false && score === 3 &&
        <img src={Image1} alt="Logo" className="set-boat7" />
      }
      {currentIndex === 3 && wrongAnswers === false && score === 2 && firstIndex === true ?
        <img src={Image1} alt="Logo" className="set-boat7-not-island" />
      :
      currentIndex === 3 && wrongAnswers === false && score === 2 && firstIndex === false &&
        <img src={Image1} alt="Logo" className="set-boat7-not-island" />
      }
      {currentIndex === 3 && wrongAnswers === true && score === 2 ?
      <>
        <img src={Image1} alt="Logo" className="set-boat7-move" />
        <div className="result-fail">
        <h1>
          You're Lost !
        </h1>
         <button onClick = {handleDetour} className="detour">Sail Back</button>
        </div>
      </>
      :
      currentIndex === 3 && wrongAnswers === true && score === 1 && firstIndex === false &&
      <img src={Image1} alt="Logo" className="set-boat7-move" />
      }
     {currentIndex === 3 && wrongAnswers === true && score === 1 && firstIndex === true &&
        <img src={Image1} alt="Logo" className="set-boat6-move" />
      }
      {currentIndex === 3 && wrongAnswers === false && score === 1 &&
        <img src={Image1} alt="Logo" className="set-boat5" />
      }
     {wrongAnswers === true && score === 0 &&
      <img src={Image1} alt="Logo" className="set-boat5-move" />
     }
      {questions.length > 0 ? (
        <>
          {currentIndex === 3 && score !== 3 &&
            <div className="result-fail">
            <h1>
              You're Lost !
            </h1>
             <button onClick = {handleDetour} className="detour">Sail Back</button>
            </div>
          }
            {currentIndex!==3 &&
            <Questionaire
              handleAnswer={handleAnswer}
              showAnswers={showAnswers}
              handleNextQuestion={handleNextQuestion}
              data={questions[currentIndex]}
            />
            }

        </>
      ) : (
        <div className="container set-center">
          <Spinner />
        </div>
      )}
    </div>
      }
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    urlloginresponseresult:state.GameReducer.urlloginresponseresult,
    prGameAttendeeId: state.GameReducer.login,
    prGameAttendeeAttemptId: state.GameReducer.login,
  };
};
export default connect(mapStateToProps, {MalwareModule,AddModuleAnswers,AddGameTime}) (Question);
